import React from "react";
import './gr-slide-item-1.scss';


export default class GrSlideItem1Component extends React.Component {

    render(){
        return (
            <div className={`slide`}> 
                <div className="item"> 
                    <p className="text-style--t1 desc">{this.props.data.content}</p>
                    <img src={this.props.data.img} alt="#" />
                    <p className="text-style--t1 name">{this.props.data.name}</p>
                    <p className="text-style--t1 position">{this.props.data.position}</p>
                </div>
            </div>
        );
    }
}